import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type { DeleteModelMutation } from '#/graphql/types';
import { deleteModel } from '#/graphql/mutations';
import { GET_ASSET_PROPS_COUNTS } from '../../hooks/useAssetPropsCountsQuery';

const q = gql(deleteModel);

const useModelDelete = () => {
  const [mutation, result] = useMutation<DeleteModelMutation>(q);
  const deleteModel = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
        refetchQueries: [{ query: GET_ASSET_PROPS_COUNTS }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.deleteModel.data', undefined);
    },
    [mutation],
  );

  return { deleteModel, result };
};

export default useModelDelete;
